<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
    <div>
        <scroll class="bg-white" @refresh="refresh">
            <div class="doctor-info">
                <div id="doct-header" class="head doc-header" v-bind:style="{backgroundImage: 'url(' +doctUrl+ ')'}">
                </div>
                <div class="info">
                    <p class="f-large ellipsis">{{doctInfo.doctLevel}}&nbsp;{{doctInfo.doctName}}</p>
                    <p class="f-minor ellipsis" style="margin-top:0.15rem">{{doctInfo.deptName}}</p>
                </div>
            </div>
            <div class="docinfo-desc row">
                {{desc}}
            </div>
        </scroll>
    </div>
</template>
<script>
    import registerService from 'register.service';

    export default {
        data(){
            return {
                doctInfo:{},
                doctUrl: '../../../static/img/ico-doctor.png',
                desc: '',
            }
        },
        mounted(){
            this.refresh();
        },
        methods: {
            refresh(){
                var params = this.$store.state.paramModule.param.doctinfo;
                this.doctInfo = params.selectdoct;
                this.loadDoctorInfo(this.doctInfo.doctId)
            },
            loadDoctorInfo: function(doctId) {
                registerService.loadDoctorInfo({doctId: doctId}).then((res) => {
                    if(res.resultCode !== this.constant.RESULT_SUCCESS){
                        this.$utils.alert(res.resultMsg);
                        return;
                    }

                    this.desc = res.data.desc;
                    if (res.data.picture != ''){
                        this.doctUrl = res.data.picture;
                    }
                });
            },
        }
    }
</script>
<style lang="scss" >
    @import '../../../static/sass/_variable.scss';
    .docinfo-desc {
        border-top: 1px solid $main-light-gray;
        overflow-y: auto;
        word-break: break-all;
    }
</style>


// WEBPACK FOOTER //
// DoctInfo.vue?65796a2a